import { Home, HomeEmployer, HomeWorker, HomeWorkerWarning } from 'containers/app/pages/home';
import WorkerRoutes from 'containers/worker/routes';
import EmployerRoutes from 'containers/employer/routes';
import AdminRoutes from 'containers/admin/routes';

import {
  Debug,
  Login,
  Signup,
  ConfirmationSent,
  ForgotPassword,
  ChangePassword,
  ProfileStages,
  ProfileComplete,
  Profile,
  EmployerDetail,
  BookingDetail,
  WorkerDetail,
  TokenPurchase,
} from './pages';

import {
  PrivacyPolicy,
  TermsGeneric,
  TermsWorker,
  TermsEmployer
} from './pages/terms';

const AppRoutes = [
  {
    name: 'Home',
    path: '/',
    component: Home,
    exact: true,
    public: true,
    nav: false,
  },
  {
    name: 'Workers',
    path: '/workers',
    component: HomeWorker,
    public: true,
    nav: false,
  },
  {
    name: 'WorkersWarning',
    path: '/workers-warning',
    component: HomeWorkerWarning,
    public: true,
    nav: false,
  },
  {
    name: 'PrivacyPolicy',
    path: '/privacy-policy',
    component: PrivacyPolicy,
    public: true,
    nav: false,
  },
  {
    name: 'TermsGeneric',
    path: '/terms-generic',
    component: TermsGeneric,
    public: true,
    nav: false,
  },
  {
    name: 'TermsWorker',
    path: '/terms-worker',
    component: TermsWorker,
    public: true,
    nav: false,
  },
  {
    name: 'TermsEmployer',
    path: '/terms-employer',
    component: TermsEmployer,
    public: true,
    nav: false,
  },
  {
    name: 'Employers',
    path: '/employers',
    component: HomeEmployer,
    public: true,
    nav: false,
  },
  {
    name: 'login',
    path: '/login/:id',
    component: Login,
    public: true,
  },
  {
    name: 'signup',
    path: '/signup/:id',
    component: Signup,
    public: true,
  },
  {
    name: 'Forgot password',
    path: '/forgot-password',
    component: ForgotPassword,
    public: true,
  },
  {
    name: 'confirmation sent',
    path: '/confirmation-sent',
    component: ConfirmationSent,
    public: false,
  },
  {
    name: 'change password',
    path: '/change-password',
    component: ChangePassword,
    public: false,
  },
  {
    name: 'Profile',
    path: '/profile',
    component: Profile,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Debug',
    path: '/debug',
    component: Debug,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Personal Details',
    path: '/update-profile',
    component: ProfileStages,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Profile Complete',
    path: '/profile-complete',
    component: ProfileComplete,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Token Purchase Success',
    path: '/token-purchase',
    component: TokenPurchase,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Employer detail',
    path: '/employer-detail/:id',
    component: EmployerDetail,
    public: false,
    confirmedUser: true,
  },
  {
    name: 'Worker detail',
    path: '/worker-detail/:id',
    component: WorkerDetail,
  },
  {
    name: 'Booking detail',
    path: '/booking-detail/:id',
    component: BookingDetail,
    public: false,
    confirmedUser: true,
  },
];

export default [
  ...AppRoutes,
  ...WorkerRoutes,
  ...EmployerRoutes,
  ...AdminRoutes,
];
